<template>
  <div class="grid-x">
    <div class="cell">
      <v-card>
        <v-card-text>
          <h1 class="display-2 grey--text">Worker Transactions Report</h1>
          <div class="filters">
            <div class="filter">
              <select name="worker_id" id="worker_id" v-model="filters.worker_id" v-if="!loadingWorkers" required>
                <option v-for="worker in workers" :value="worker.id">
                  {{ worker.first_name }} {{ worker.last_name }} - {{ worker.email }}
                </option>
              </select>
            </div>
            <div class="filter">
              <select name="transaction_type" id="transaction_type" v-model="filters.transaction_type">
                <option value="">
                  All transaction types
                </option>
                <option v-for="trans in transTypes" :value="trans">
                  {{ trans}}
                </option>
              </select>
            </div>
            <div class="filter">
              <input type="date" v-model="filters.start_date" />
            </div>
            <div class="filter">
              <input type="date" v-model="filters.end_date" />
            </div>
            <div>
              <v-btn primary @click="getData()">Search</v-btn>
            </div>
          </div>
          <div class="stats" v-if="meta">
            <p>Total Paid Invoices: {{ meta.total }}</p>
            <p>Total Paid Invoices Amount: {{ meta.total_value }}</p>
            <ul style="padding-left:0;">
              <li v-if="meta.totals_by_type.cash">Cash: {{ meta.totals_by_type.cash.formatted }} ({{ meta.totals_by_type.cash.count }})</li>
              <li v-if="meta.totals_by_type.card">Card: {{ meta.totals_by_type.card.formatted }} ({{ meta.totals_by_type.card.count }})</li>
              <li v-if="meta.totals_by_type.online">Online: {{ meta.totals_by_type.online.formatted }} ({{ meta.totals_by_type.online.count }})</li>
              <li v-if="meta.totals_by_type.check">Check: {{ meta.totals_by_type.check.formatted }} ({{ meta.totals_by_type.check.count }})</li>
            </ul>
          </div>
          <table class v-if="results.length > 0">
            <thead>
            <tr>
              <th>Invoice Id</th>
              <th>Order Id</th>
              <th>Type</th>
              <th>Value</th>
              <th>Cash Received</th>
              <th>Change Given</th>
              <th>Transaction Date</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(result, i) in results" :key="i">
              <td>{{ result.invoice_pseudo_id }}</td>
              <td>{{ result.order_id }}</td>
              <td>{{ result.type }}</td>
              <td>{{ result.value }}</td>
              <td>{{ result.cash_received }}</td>
              <td>{{ result.change_given }}</td>
              <td>{{ result.transaction_date }}</td>
            </tr>
            </tbody>
          </table>
          <div class="pagination-dropdown" v-if="meta">
            <select
                v-model="current_page"
                class="pagination"
                @change="changePage()"
            >
              <option
                  v-for="(page, i) in meta.last_page"
                  :key="i"
                  :value="page"
              >
                Page: {{ page }}
              </option>
            </select>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  created() {
    this.getWorkers();
  },

  data: () => {
    return {
      results: [],
      workers: [],
      transTypes: [
          'cash',
          'online',
          'card',
          'check'
      ],
      meta: null,
      current_page: 1,
      loadingWorkers: false,
      related_orders: [],
      filters: {
        worker_id: null,
        transaction_type: "",
        start_date: null,
        end_date: null,
      },
    };
  },
  computed: {
    ...mapGetters(["authUser"]),
  },
  methods: {
    ...mapActions(["fetchWorkerTransactionReport", "fetchWorkers"]),
    getWorkers() {
      this.loadingWorkers = true;
      this.fetchWorkers()
          .then((response) => {
            this.workers = response.data;
            this.filters.worker_id = this.authUser.id
            this.loadingWorkers = false;
          })
    },

    getData() {
      let payload = {
        filters: this.filters,
        page: this.current_page,
      };

      this.fetchWorkerTransactionReport(payload).then((res) => {
        this.results = res.data;
        this.meta = res.meta;
        this.current_page = res.meta.current_page;
      });
    },
    changePage() {
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.order-link {
  color: blue;
}
.pagination {
  padding: 10px;
  border: 1px solid #000000;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
}

.filters {
  margin-top: 16px;
  margin-bottom: 16px;
}
table {
  border-collapse: collapse;
  background-color: #ffffff;
  margin: 0 auto;
  th {
    padding: 0.75rem;
  }
}
table tr:nth-child(even) {
  background-color: #ddd;
}
tbody tr {
  // cursor: pointer;
  td {
    text-align: right;
    padding: 0.75rem;
    a {
      color: black;
    }
  }
}
.filter input, .filter select {
  padding: 4px;
  border: 1px solid #000000;
  margin-bottom: 6px;
}
</style>
